// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"a622c4d1","453":"02657a8f","455":"bf7ba137","977":"e017e791"}[chunkId] + ".chunk.js";
};